import { PrimaryWeaponAttack, PrimaryWeaponAttackConfig, SecondaryWeaponAttack } from 'game/core'
import { AbilityUI } from 'game/extended/uis/abilities/AbilityUI'
import React from 'react'

import image from './secondary_weapon_attack.png'
import { secondary_weapon_attack_config } from './secondary_weapon_attack_config'

export const secondary_weapon_attack_ui: AbilityUI<'SecondaryWeaponAttack'> = {
    model: SecondaryWeaponAttack,
    configs: secondary_weapon_attack_config,
    image,
    label: 'Secondary Weapon Attack',
    renderTargets: () => 'Weapon target',
    renderDescription: () => <>
        Use your secondary weapon to attack.
    </>,
    renderImpression: (ability: PrimaryWeaponAttack, UI) => <>
        <UI.Char character={ability.character} />{' '}lifts {ability.character?.isFemale ? 'her' : 'his'} {ability.weapon?.category} and
        strikes{' '}<UI.Char character={ability.targets} />.
    </>,
    renderTableStatic: (ability: PrimaryWeaponAttackConfig, UI) => <>
        <UI.TRow>
            <UI.TKey>Damage:</UI.TKey>
            <UI.TVal>Weapon damage</UI.TVal>
        </UI.TRow>
    </>,
    renderTable: (ability, UI) => <>
        <UI.TRow>
            <UI.TKey>Damage:</UI.TKey>
            <UI.TVal><UI.Damage damage={ability.damage} /></UI.TVal>
        </UI.TRow>
    </>
}
